import React, { createContext, useContext, useEffect, useState } from 'react';
import { getNativeStorage, setNativeStorage } from '../services/api';

// 백엔드 timeFrame 파라미터.
//   /api/v1/open/dashboard/coin-ranking/{tf}
//   /api/v1/open/crypto-detail/{ticker}/{kind}/{tf}
//   /api/v1/open/report/{ticker}/{type}/{tf}
//
// TIMEFRAMES: 향후 노출될 수 있는 모든 후보 (UI는 이 순서대로 렌더링).
// SUPPORTED_TIMEFRAMES: 현재 백엔드가 실제로 200을 돌려주는 값.
//   라이브 검증(2026-05-12) — 1d/8h 외 전부 400/404. 백엔드가 추가되면
//   이 배열에만 추가하면 UI가 자동으로 활성화된다.
export const TIMEFRAMES = ['1d', '8h', '4h', '2h', '1h', '30m', '15m', '5m', '3m', '1m'];
export const SUPPORTED_TIMEFRAMES = ['1d', '8h'];

export const TIMEFRAME_LABELS = {
  '1d':  '1일',
  '8h':  '8시간',
  '4h':  '4시간',
  '2h':  '2시간',
  '1h':  '1시간',
  '30m': '30분',
  '15m': '15분',
  '5m':  '5분',
  '3m':  '3분',
  '1m':  '1분',
};

const DEFAULT_TF = '1d';
const STORAGE_KEY = 'timeFrame';

export const isSupportedTimeFrame = (tf) => SUPPORTED_TIMEFRAMES.includes(tf);
const normalize = (v) => (SUPPORTED_TIMEFRAMES.includes(v) ? v : DEFAULT_TF);

const TimeFrameContext = createContext({ timeFrame: DEFAULT_TF, setTimeFrame: () => {} });

export const TimeFrameProvider = ({ children }) => {
  const [timeFrame, setTimeFrameState] = useState(() => {
    try {
      return normalize(localStorage.getItem(STORAGE_KEY) || DEFAULT_TF);
    } catch {
      return DEFAULT_TF;
    }
  });

  // 네이티브 storage에서 비동기로 한번 hydrate (앱 재시작 시 iOS UserDefaults 값 우선)
  // services/api.js의 getNativeStorage()는 JSON envelope + 단일-flight Promise 패턴을
  // 안전하게 처리하므로 그대로 사용한다.
  useEffect(() => {
    let cancelled = false;
    getNativeStorage(STORAGE_KEY)
      .then((value) => {
        if (cancelled || !value) return;
        const n = normalize(value);
        setTimeFrameState((prev) => (prev === n ? prev : n));
      })
      .catch(() => {});
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setTimeFrame = (next) => {
    const n = normalize(next);
    setTimeFrameState(n);
    try { localStorage.setItem(STORAGE_KEY, n); } catch {}
    try { setNativeStorage(STORAGE_KEY, n); } catch {}
  };

  return (
    <TimeFrameContext.Provider value={{ timeFrame, setTimeFrame }}>
      {children}
    </TimeFrameContext.Provider>
  );
};

export const useTimeFrame = () => useContext(TimeFrameContext);
